import Hamburger from "hamburger-react";
import { useState } from "react";
import { Link } from "react-scroll";
import Sidebar from "../SideBar/Sidebar";
import Logo from "../../assets/apple-touch-icon.png";

export default function Header() {
  const [isOpen, setOpen] = useState(false);

  const navLinks = [
    { id: 0, name: "Home", path: "home" },
    { id: 1, name: "About", path: "about" },
    { id: 2, name: "Projects", path: "works" },
    { id: 3, name: "Contact", path: "contact-me" },
  ];
  return (
    <>
      <header className="p-4 fixed w-full items-center bg-[#191919] border-b border-[#dfdfdf] z-10 shadow-md">
        <nav className="container mx-auto flex items-center justify-between max-w-[1440px]">
          <div className="">
            <h1 className="font-head text-[5vw] md:text-[2vw] tracking-widest  flex items-center">
              {/* <div className="h-4 w-4 inline-flex items-center rounded-full bg-[#f34c08]"></div> */}
              <a href="/" className="">
                {/* joshua */}
                <img
                  src={Logo}
                  className="w-[60px] h-[55px] mix-blend-screen"
                  alt=""
                />
              </a>
              {/* <span className="text-4xl items-center text-[#FAF991]">.</span> */}
            </h1>
            {/* #FAF991, #D1C56C, #07080A, #3D3E41, #B5B5B5, #7E7F80 */}
          </div>

          <div className="">
            <div className="hidden lg:flex">
              <ul className="flex flex-row">
                {navLinks.map((items, index) => (
                  <li
                    key={index}
                    className="text-base p-4 cursor-pointer font-sanss uppercase"
                  >
                    <Link
                      to={items.path}
                      activeClass="active"
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}
                      className=""
                    >
                      {items.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="lg:hidden">
              <Hamburger
                color="#f34c08"
                label="Show menu"
                distance="md"
                rounded
                hideOutline={false}
                size={28}
                toggled={isOpen}
                toggle={setOpen}
              />
            </div>
          </div>
        </nav>
      </header>
      {isOpen && (
        <Sidebar navLinks={navLinks} isOpen={isOpen} setOpen={setOpen} />
      )}
    </>
  );
}
